import React, { useEffect, useState } from "react";
import { getAllConcepts, getAllTrainers, getAllUsers } from "../../api";
import {
  Avatar,
  BlogsSvg,
  ConceptsSvg,
  EventsSvg,
  ForumsSvg,
  TrainersSvg,
  UsersSvg,
} from "../../assets";
import { actionType } from "../../context/reducer";
import { useStateValue } from "../../context/StateProvider";

import { motion } from "framer-motion";
import { useRef } from "react";
import { imageWhileHover } from "../../utils/animations";

export const Card = ({ imgSrc, count, name }) => {
  return (
    <div className="bg-card shadow-md p-4 min-w-[100px] min-h-[130px] md:min-w-160  rounded-md  flex flex-col items-center justify-evenly gap-3">
      <img src={imgSrc} className="w-10 md:w-20 md:h-20" alt="" />
      <p className="text-headingColor text-base md:text-md text-center font-semibold">
        {name}
        <span className="block">{count}</span>
      </p>
    </div>
  );
};

export const UserCard = ({ data }) => {
  return (
    <>
      <motion.div className="w-full relative sm:w-190 sm:min-w-[190px] p-3 bg-card shadow-md rounded-md hidden sm:flex flex-col items-center justify-center">
        <div className="absolute p-1 bg-lightOverlay backdrop-blur-md rounded-md right-4 top-4">
          <p className="text-sm text-headingColor font-semibold">
            {data?.emailVerified ? "Verified" : "Not Verified"}
          </p>
        </div>
        <div className="w-full h-32 overflow-hidden flex items-center justify-center">
          <motion.img
            {...imageWhileHover}
            src={data?.photoURL ? data?.photoURL : Avatar}
            className="w-full h-full object-cover rounded-md"
            referrerPolicy="no-referrer"
          />
        </div>
        <p className="text-md text-center text-textColor my-2 capitalize font-semibold">
          {data?.displayName}
        </p>
        <p className="text-sm text-center text-textColor my-2 capitalize font-semibold">
          {data?.email?.length > 20
            ? `${data.email?.slice(0, 20)}..`
            : data?.email}
        </p>
      </motion.div>
      <motion.div
        key={data.uid}
        className="w-full relative sm:w-190 sm:min-w-[190px] p-3 bg-card shadow-md rounded-md flex sm:hidden items-center justify-start gap-4"
      >
        <div className="absolute p-1 bg-lightOverlay shadow-lg backdrop-blur-md rounded-md right-4 top-4">
          <p className="text-sm text-green-700 font-semibold">
            {data?.emailVerified ? "Verified" : "Not Verified"}
          </p>
        </div>
        <div className="w-12 h-12 overflow-hidden shadow-md drop-shadow-md rounded-md flex items-center justify-center">
          <motion.img
            {...imageWhileHover}
            src={data?.photoURL ? data?.photoURL : Avatar}
            className="w-full h-full object-cover rounded-md"
            referrerPolicy="no-referrer"
          />
        </div>
        <p className="text-xl text-left  text-textColor my-2 capitalize font-semibold">
          {data?.displayName}
          <span className="text-sm block text-textColor  capitalize font-semibold">
            {data?.email}
          </span>
        </p>
      </motion.div>
    </>
  );
};

const Home = () => {
  const [{ allUsers, mainLoader, allTrainers, allConcepts }, dispatch] =
    useStateValue();
  const [index, setIndex] = useState(20);
  const effectRun = useRef();

  useEffect(() => {
    // if (effectRun.current === true) {
    if (!allUsers) {
      dispatch({ type: actionType.SET_MAIN_LOADER, mainLoader: true });

      dispatch({ type: actionType.SET_USERS, allUsers: null });
      getAllUsers().then((user) => {
        dispatch({ type: actionType.SET_USERS, allUsers: user.data });
      });
      setTimeout(() => {
        dispatch({ type: actionType.SET_MAIN_LOADER, mainLoader: false });
      }, 3000);
    }

    if (!allTrainers) {
      dispatch({ type: actionType.SET_MAIN_LOADER, mainLoader: true });

      getAllTrainers().then((trainer) => {
        dispatch({
          type: actionType.SET_TRAINERS,
          allTrainers: trainer.data,
        });
      });
      setTimeout(() => {
        dispatch({ type: actionType.SET_MAIN_LOADER, mainLoader: false });
      }, 3000);
    }

    if (!allConcepts) {
      dispatch({ type: actionType.SET_MAIN_LOADER, mainLoader: true });

      getAllConcepts().then((concept) => {
        dispatch({
          type: actionType.SET_CONCEPTS,
          allConcepts: concept.data,
        });
      });
      setTimeout(() => {
        dispatch({ type: actionType.SET_MAIN_LOADER, mainLoader: false });
      }, 3000);
    }
    // }
    return () => {
      // effectRun.current = true;
    };
  }, [index]);

  return (
    <div className=" w-full flex flex-col items-center justify-center">
      <div className=" w-full flex items-center justify-between flex-wrap gap-4">
        <Card name={"Users"} imgSrc={UsersSvg} count={allUsers?.length} />
        <Card
          name={"Trainers"}
          imgSrc={TrainersSvg}
          count={allTrainers?.length}
        />
        <Card
          name={"Concepts"}
          imgSrc={ConceptsSvg}
          count={allConcepts?.length}
        />
        <Card name={"Blogs"} imgSrc={BlogsSvg} count={0} />
        <Card name={"Forums"} imgSrc={ForumsSvg} count={0} />
        <Card name={"Events"} imgSrc={EventsSvg} count={0} />
      </div>

      <p className="text-textColor text-3xl font-semibold my-6">
        List of Users
      </p>
      <div className="w-full flex flex-wrap items-center justify-evenly gap-4 my-4">
        {allUsers &&
          allUsers.slice(0, index).map((n, i) => <UserCard key={i} data={n} />)}
      </div>
      <div className="w-full flex items-center justify-center mt-4">
        <p
          className="px-8 py-2 rounded-full bg-card shadow-md mb-4 cursor-pointer"
          onClick={() => setIndex(index + 20)}
        >
          Load More
        </p>
      </div>
    </div>
  );
};

export default Home;
